import { apiSlice } from "@/shared/api/api-slice"
import { chatIdMutation } from "@/shared/api/queries"

import type { SetUserCardStyleRequest, SetUserCardStyleResponse } from "./card-style-types"
import { getUserCardStyleTag } from "./get-user-card-style"

export const setUserCardStyleApi = apiSlice
  .enhanceEndpoints({
    addTagTypes: ["UserCardStyle", "Balance", "GroupRating", "Statistics"]
  })
  .injectEndpoints({
    endpoints: builder => ({
      setUserCardStyle: builder.mutation<SetUserCardStyleResponse, SetUserCardStyleRequest>({
        queryFn: chatIdMutation<SetUserCardStyleRequest, SetUserCardStyleResponse>((chatId, arg) => ({
          url: "/api/v1/card-styles/me",
          method: "PUT",
          body: { chat_id: chatId, style_id: arg.styleId }
        })),
        invalidatesTags: (_result, error, { chatId }) =>
          error ? [] : [getUserCardStyleTag(chatId), "Balance", "GroupRating", "Statistics"]
      })
    })
  })

export const { useSetUserCardStyleMutation } = setUserCardStyleApi
